import {formFieldValue} from '../selectors/formFieldValue';

export default function(form){
  const name = formFieldValue(form, 'leadform');
  if(name) {
    // match vt or vp anywhere except within a word i.e. "vp_govt_leadform" matches vp but not vt
    // (?:\b|_) matches a word boundary or underscore boundary, and excludes it from match[1]
    const match = name.match(/(?:\b|_)(vt|vp)(?:\b|_)/);
    if (match) return match[1];
  }
  return '';
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/form/formBrand.js